import { render, staticRenderFns } from "./CodeInjector.vue?vue&type=template&id=25c844dc"
import script from "./CodeInjector.vue?vue&type=script&lang=ts"
export * from "./CodeInjector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports